var _defs, _g, _g2, _g3, _g4, _g5, _path, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 295.557,
    height: 514.04,
    viewBox: "0 0 295.557 514.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.av,.ay,.bd{opacity:0.3;}.aa,.ab,.ac,.ad,.ae,.af,.ag,.ah,.ai,.aj,.ak,.al,.am,.an,.ao,.ap,.aq,.av,.b,.bi,.c,.d,.e,.f,.g,.h,.i,.j,.k,.l,.m,.n,.o,.p,.q,.r,.s,.t,.u,.v,.w,.x,.y,.z{fill:#05105d;}.b{opacity:0;}.c{opacity:0.024;}.d{opacity:0.049;}.e{opacity:0.073;}.f{opacity:0.098;}.g{opacity:0.122;}.h{opacity:0.146;}.i{opacity:0.171;}.j{opacity:0.195;}.k{opacity:0.22;}.l{opacity:0.244;}.m{opacity:0.268;}.n{opacity:0.293;}.o{opacity:0.317;}.p{opacity:0.341;}.q{opacity:0.366;}.r{opacity:0.39;}.s{opacity:0.415;}.t{opacity:0.439;}.u{opacity:0.463;}.v{opacity:0.488;}.w{opacity:0.512;}.x{opacity:0.537;}.y{opacity:0.561;}.z{opacity:0.585;}.aa{opacity:0.61;}.ab{opacity:0.634;}.ac{opacity:0.659;}.ad{opacity:0.683;}.ae{opacity:0.707;}.af{opacity:0.732;}.ag{opacity:0.756;}.ah{opacity:0.78;}.ai{opacity:0.805;}.aj{opacity:0.829;}.ak{opacity:0.854;}.al{opacity:0.878;}.am{opacity:0.902;}.an{opacity:0.927;}.ao{opacity:0.951;}.ap{opacity:0.976;}.ar{fill:url(#a);}.as{fill:#fefeff;}.at{fill:#0c4da4;}.au{fill:#1067db;}.aw{fill:url(#b);}.ax{fill:#f3f8fe;}.ay{fill:#48486a;}.az{fill:#f9b888;}.ba{fill:#1ca2f9;}.bb{fill:url(#c);}.bc{fill:#fff;}.bd{fill:#231f20;}.be{fill:#f2b1b5;}.bf{fill:#37407d;}.bg{fill:url(#d);}.bh{fill:url(#e);}.bi{opacity:0.2;}.bj{fill:url(#f);}.bk{fill:#e5e9f4;}.bl{fill:url(#g);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.847,
    y1: 0.929,
    x2: 0.098,
    y2: -0.013,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.038,
    stopColor: "#1067db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ca2f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 4.81,
    y1: 0.5,
    x2: 5.81,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#071e71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.213,
    stopColor: "#092e89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#0b44a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.812,
    stopColor: "#0d52bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e57c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec55e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe836"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -0.195,
    y1: 0.613,
    x2: 1.056,
    y2: 0.399,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2876df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ca2f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 19.67,
    y1: 1.027,
    x2: 20.877,
    y2: -0.049,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.555,
    y1: 0.5,
    x2: 1.555,
    y2: 0.5,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -0.144,
    y1: 0.742,
    x2: 1.104,
    y2: 0.273,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec55e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.361,
    stopColor: "#fece53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#fee736"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe836"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 331.214)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M151.562,240.094,48.256,297.705l120.97,71.418,103.306-59.187Z",
    transform: "translate(-48.256 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M150,240.094,49.058,296.384,170,367.785l100.972-57.848Z",
    transform: "translate(-46.695 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M148.441,240.094l-98.58,54.969,120.912,71.384,98.638-56.51Z",
    transform: "translate(-45.134 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M146.88,240.094,50.663,293.741l120.883,71.367,96.3-55.171Z",
    transform: "translate(-43.574 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M145.319,240.094,51.466,292.42,172.32,363.769l93.97-53.833Z",
    transform: "translate(-42.013 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M143.759,240.094l-91.49,51L173.093,362.43l91.635-52.494Z",
    transform: "translate(-40.452 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M142.2,240.094,53.071,289.776l120.8,71.315,89.3-51.155Z",
    transform: "translate(-38.892 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M140.637,240.094,53.874,288.455l120.767,71.3,86.967-49.817Z",
    transform: "translate(-37.331 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M139.077,240.094l-84.4,47.039,120.737,71.281,84.633-48.478Z",
    transform: "translate(-35.77 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M137.516,240.094,55.479,285.812l120.708,71.264,82.3-47.139Z",
    transform: "translate(-34.21 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M135.955,240.094l-79.674,44.4,120.679,71.247,79.965-45.8Z",
    transform: "translate(-32.649 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M134.395,240.094,57.084,283.169,177.734,354.4l77.631-44.462Z",
    transform: "translate(-31.088 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M132.834,240.094,57.886,281.847,178.507,353.06l75.3-43.123Z",
    transform: "translate(-29.528 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M131.273,240.094,58.689,280.526l120.592,71.195,72.962-41.785Z",
    transform: "translate(-27.967 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M129.713,240.094,59.491,279.2l120.563,71.178,70.628-40.446Z",
    transform: "translate(-26.406 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M128.152,240.094,60.294,277.883l120.534,71.161,68.294-39.107Z",
    transform: "translate(-24.845 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M126.591,240.094,61.1,276.562,181.6,347.7l65.96-37.768Z",
    transform: "translate(-23.285 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M125.03,240.094,61.9,275.24l120.476,71.126L246,309.936Z",
    transform: "translate(-21.724 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M123.47,240.094,62.7,273.918l120.447,71.109,61.292-35.091Z",
    transform: "translate(-20.163 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M121.909,240.094,63.5,272.6l120.418,71.092,58.958-33.752Z",
    transform: "translate(-18.603 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M120.348,240.094,64.306,271.275,184.695,342.35l56.623-32.414Z",
    transform: "translate(-17.042 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M118.788,240.094l-53.679,29.86,120.36,71.058,54.289-31.075Z",
    transform: "translate(-15.481 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M117.227,240.094,65.911,268.632l120.33,71.04L238.2,309.936Z",
    transform: "translate(-13.921 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M115.666,240.094,66.714,267.311l120.3,71.023,49.621-28.4Z",
    transform: "translate(-12.36 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M114.106,240.094l-46.589,25.9L187.788,337l47.287-27.059Z",
    transform: "translate(-10.799 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M112.545,240.094,68.319,264.668l120.243,70.989,44.953-25.721Z",
    transform: "translate(-9.239 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M110.984,240.094,69.121,263.346l120.214,70.972,42.619-24.382Z",
    transform: "translate(-7.678 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M109.424,240.094l-39.5,21.931L190.109,332.98l40.284-23.043Z",
    transform: "translate(-6.117 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M107.863,240.094,70.726,260.7l120.156,70.938,37.951-21.7Z",
    transform: "translate(-4.557 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M106.3,240.094,71.529,259.382,191.656,330.3l35.616-20.366Z",
    transform: "translate(-2.996 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M104.741,240.094,72.331,258.06l120.1,70.9,33.282-19.027Z",
    transform: "translate(-1.435 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M103.181,240.094,73.134,256.739,193.2,327.625l30.948-17.688Z",
    transform: "translate(0.126 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M101.62,240.094,73.936,255.417l120.04,70.869,28.614-16.35Z",
    transform: "translate(1.686 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M100.059,240.094l-25.32,14L194.75,324.948l26.28-15.011Z",
    transform: "translate(3.247 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M98.5,240.094l-22.957,12.68,119.982,70.834,23.946-13.672Z",
    transform: "translate(4.808 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M96.938,240.094,76.344,251.453,196.3,322.27l21.612-12.334Z",
    transform: "translate(6.368 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M95.377,240.094,77.146,250.131l119.923,70.8,19.278-11Z",
    transform: "translate(7.929 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M93.817,240.094,77.949,248.81l119.894,70.783,16.943-9.656Z",
    transform: "translate(9.49 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M92.256,240.094l-13.5,7.394,119.865,70.766,14.609-8.318Z",
    transform: "translate(11.05 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M90.7,240.094l-11.141,6.073L199.39,316.916l12.275-6.979Z",
    transform: "translate(12.611 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M89.135,240.094l-8.778,4.751,119.807,70.732,9.941-5.64Z",
    transform: "translate(14.172 -240.094)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M87.574,240.094l-6.415,3.43,119.778,70.714,7.607-4.3Z",
    transform: "translate(15.732 -240.094)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(95.407 44.685)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ar",
    d: "M84.525,147.29l-1.334,6.617c-1.625,1.125-1.755,8.363-1.755,10.339l2.106,250.966c0,12.1,6.343,20.94,16.823,26.992L190.1,495.13c1.484.854,3.289,4.773,4.906,4.208l8.528,1.767a22.31,22.31,0,0,0,14.927-21.055V230.268c0-12.1-8.575-26.95-19.055-33L114.314,148.2C103.722,142.093,94.576,140.326,84.525,147.29Z",
    transform: "translate(-79.136 -142.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M99.708,146.423c-10.48-6.049-19.053-1.1-19.053,11v254.5c0,12.1,8.572,26.95,19.053,33l92.318,53.3c10.48,6.051,19.055,1.1,19.055-11v-254.5c0-12.1-8.575-26.95-19.055-33Z",
    transform: "translate(-80.655 -140.753)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.563 34.926)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M128.242,175.74a2.189,2.189,0,0,1-1.1-.294l-28.9-16.685a2.2,2.2,0,0,1,2.2-3.811l28.9,16.685a2.2,2.2,0,0,1-1.1,4.1Z",
    transform: "translate(-97.146 -154.653)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M93.317,147.5l22.339,12.9a2.526,2.526,0,0,1,1.269,2.194v4.111a12.984,12.984,0,0,0,6.49,11.243l38.273,22.1a4.45,4.45,0,0,0,6.673-3.855v-3.018A1.354,1.354,0,0,1,170.393,192l16.276,9.4a31.971,31.971,0,0,1,15.984,27.69V481.572a7.455,7.455,0,0,1-11.181,6.458l-92.71-53.583a32.583,32.583,0,0,1-16.279-28.164l-.35-252.309A7.455,7.455,0,0,1,93.317,147.5Z",
    transform: "translate(-77.781 -135.595)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.249 52.674)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M147.24,193.25,80.574,154.762v72.889l66.666,38.491a5.809,5.809,0,0,0,2.447.816,3.75,3.75,0,0,0,.86-.044,3.062,3.062,0,0,0,.342-.088,2.864,2.864,0,0,0,.5-.191,2.619,2.619,0,0,0,.3-.159,3.251,3.251,0,0,0,.533-.436c.041-.044.088-.071.127-.115a3.673,3.673,0,0,0,.495-.766c.047-.091.082-.188.121-.283a5.217,5.217,0,0,0,.239-.742c.024-.106.053-.209.071-.321a6.859,6.859,0,0,0,.115-1.219V203.9a13.741,13.741,0,0,0-3.76-8.708A10.588,10.588,0,0,0,147.24,193.25Z",
    transform: "translate(-30.654 -127.504)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M175.252,206.975a12.685,12.685,0,0,1,5.719,9.906v54.6c0,3.631-2.571,5.115-5.719,3.3l-106-61.2a12.474,12.474,0,0,1-5.633-9.9l.7-54.1c.047-3.631,2.656-5.118,5.8-3.3Z",
    transform: "translate(-63.622 -145.506)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aw",
    d: "M177.168,273.531v-54.6a12.688,12.688,0,0,0-5.719-9.9l-105.128-60.7a5.3,5.3,0,0,0-2.332-.754c.825-2.1,2.948-2.733,5.424-1.3l105.125,60.694a12.685,12.685,0,0,1,5.719,9.906v54.6c0,2.7-1.422,4.205-3.442,4.058A5.566,5.566,0,0,0,177.168,273.531Z",
    transform: "translate(-62.908 -145.501)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.98 25.133)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M83.314,156.48c-9.9-5.716-18-1.039-18,10.395s8.1,25.466,18,31.185,18,1.037,18-10.395S93.217,162.2,83.314,156.48Z",
    transform: "translate(-65.313 -154.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M85.873,167.261l-10.1-5.089a6.034,6.034,0,0,0-8.74,5.7l.079,1.888c3.278,5.781,7.845,10.848,12.883,13.758,3.484,2.011,6.741,2.733,9.5,2.329.144-3.607.274-7.268.224-10.095C89.657,172.255,88.994,168.833,85.873,167.261Z",
    transform: "translate(-61.991 -139.497)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "M75.19,164.856a2.578,2.578,0,0,0-2.459,2.692l.507,11.373a12.237,12.237,0,0,0,5.159.439l.009-.253-.524-11.788A2.582,2.582,0,0,0,75.19,164.856Z",
    transform: "translate(-50.893 -133.013)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "M75.05,164.868a2.578,2.578,0,0,0-2.229,2.883l1.458,11.47a11.006,11.006,0,0,0,5.186-.1L77.933,167.1A2.58,2.58,0,0,0,75.05,164.868Z",
    transform: "translate(-50.753 -133.025)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.723 31.502)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M76.81,178.846q.1,0,.2-.018a2.9,2.9,0,0,0,2.512-3.245l-1.057-8.313a2.9,2.9,0,0,0-5.754.733l1.057,8.313A2.9,2.9,0,0,0,76.81,178.846Z",
    transform: "translate(-72.69 -164.738)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "M72.927,169.5h0a2.346,2.346,0,0,0,2.206-2.474l-.3-5.312-4.679.268.3,5.312A2.345,2.345,0,0,0,72.927,169.5Z",
    transform: "translate(-55.906 -139.118)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ba",
    d: "M74.044,162.478l1.326.61-1.9,8.757-2.849-3.754Z",
    transform: "translate(-54.993 -137.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ba",
    d: "M73.181,169.092l-1.356-7.129-.6.034L69.3,170.517Z",
    transform: "translate(-57.554 -138.632)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "M76.251,170.924h0a4.505,4.505,0,0,0,3.967-4.986l-.907-7.966L68.017,159.26l.642,5.624A6.857,6.857,0,0,0,76.251,170.924Z",
    transform: "translate(-60.054 -146.393)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M68.028,161.076a6.3,6.3,0,0,1,.244-.875,3.863,3.863,0,0,1,.61-1.178,4.426,4.426,0,0,1,1-.851,5.963,5.963,0,0,1,2.983-1.266c2.279-.171,4.676-.186,6.523,1.369a2.876,2.876,0,0,1,.886,1.207.529.529,0,0,0,.077.165.444.444,0,0,0,.159.106,2.7,2.7,0,0,1,1.128.7,4.854,4.854,0,0,1,.527,1.222,9.961,9.961,0,0,1,.53,2.5,12.5,12.5,0,0,1-.707,5.009c-.28.822-.783,2.78-1.879,2.921a.429.429,0,0,1-.418-.3,1.238,1.238,0,0,1-.035-.551c.071-.827.141-1.652.212-2.479a1.071,1.071,0,0,0-.133-.78.687.687,0,0,0-.857-.094c-.521.306-.548.992-.854,1.464a.559.559,0,0,1-.392.3c-.227.015-.389-.218-.471-.433-.5-1.287.35-3.065-.733-4.073-1.3-1.207-2.441.044-3.625.663a1.5,1.5,0,0,1-1.307.115,2.1,2.1,0,0,1-.9-1.372c-.174-.542-.592-1.184-1.275-.73-.271.18-.539.592-.9.336-.218-.156-.368-.925-.424-1.175A4.717,4.717,0,0,1,68.028,161.076Z",
    transform: "translate(-60.251 -148.616)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M68.422,161.829a1.8,1.8,0,0,1,.392.777.948.948,0,0,0,.08.274c.253.442.71-.324.845-.5.5-.663,1.24-.483,1.958-.362a1.665,1.665,0,0,1,.978.4,1.816,1.816,0,0,1,.321.6,1.533,1.533,0,0,0,.333.589,1.262,1.262,0,0,0,1.39.053,2.821,2.821,0,0,0,1.419-1.64c.121-.374.233-1.67.957-1.254.53.306-.062,1.3-.088,1.755-.044.783.642,1.517.486,2.267a3.778,3.778,0,0,1-.789,1.169,2.878,2.878,0,0,1-1.1.872,5.378,5.378,0,0,1-1.213.339,9.787,9.787,0,0,1-2.789.23,3.71,3.71,0,0,1-2.471-1.184,2.968,2.968,0,0,1-.6-1.935c-.024-.442-.121-.883-.135-1.331C68.392,162.762,68.522,161.943,68.422,161.829Z",
    transform: "translate(-59.314 -141.12)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.39 46.912)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M136.753,198.171,79.382,165.153l-.007-3.717,57.378,32.957Z",
    transform: "translate(-79.375 -161.436)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.39 59.641)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M136.753,202.388,79.375,169.471v-3.712l57.378,32.957Z",
    transform: "translate(-79.375 -165.759)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.39 73.141)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M111.292,192.314,79.375,174.056v-3.713l31.916,18.3Z",
    transform: "translate(-79.375 -170.343)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(126.763 273.38)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "M134.688,244.347a4.922,4.922,0,0,1,2.223,3.849v21.22c0,1.411-1,1.988-2.223,1.281l-41.2-23.785a4.846,4.846,0,0,1-2.188-3.849l.271-21.026c.018-1.411,1.034-1.988,2.256-1.281Z",
    transform: "translate(-91.303 -220.455)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.153 260.617)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 200.854)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M120.109,284.328l-65.689,35.3L83.663,336.9l65.689-35.686Z",
    transform: "translate(-54.42 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M119.076,284.328,54.952,318.792l29.236,17.26,64.131-34.841Z",
    transform: "translate(-53.387 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M118.043,284.328l-62.56,33.623,29.229,17.256,62.574-34Z",
    transform: "translate(-52.354 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M117.01,284.328l-61,32.782,29.222,17.252,61.016-33.151Z",
    transform: "translate(-51.321 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M115.976,284.328,56.545,316.269,85.76,333.517l59.459-32.306Z",
    transform: "translate(-50.288 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M114.943,284.328l-57.867,31.1,29.208,17.244,57.9-31.461Z",
    transform: "translate(-49.255 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M113.91,284.328l-56.3,30.26,29.2,17.24,56.345-30.616Z",
    transform: "translate(-48.222 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M112.877,284.328,58.139,313.747l29.194,17.235,54.787-29.771Z",
    transform: "translate(-47.189 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M111.844,284.328,58.67,312.906l29.187,17.231,53.23-28.926Z",
    transform: "translate(-46.155 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M110.811,284.328,59.2,312.065l29.18,17.227,51.673-28.081Z",
    transform: "translate(-45.122 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M109.778,284.328l-50.045,26.9,29.173,17.223,50.115-27.236Z",
    transform: "translate(-44.089 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M108.745,284.328,60.264,310.383,89.429,327.6l48.558-26.391Z",
    transform: "translate(-43.056 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M107.712,284.328,60.8,309.542l29.159,17.215,47-25.546Z",
    transform: "translate(-42.023 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M106.678,284.328,61.326,308.7l29.152,17.21,45.443-24.7Z",
    transform: "translate(-40.99 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M105.645,284.328,61.858,307.86,91,325.067l43.886-23.856Z",
    transform: "translate(-39.957 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M104.612,284.328,62.389,307.02l29.138,17.2,42.329-23.011Z",
    transform: "translate(-38.924 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M103.579,284.328,62.92,306.179l29.131,17.2,40.772-22.165Z",
    transform: "translate(-37.891 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M102.546,284.328l-39.095,21.01,29.124,17.194,39.214-21.321Z",
    transform: "translate(-36.857 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M101.513,284.328,63.982,304.5,93.1,321.687l37.657-20.475Z",
    transform: "translate(-35.824 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M100.48,284.328,64.514,303.656l29.109,17.186,36.1-19.631Z",
    transform: "translate(-34.791 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M99.447,284.328l-34.4,18.487L94.147,320l34.542-18.785Z",
    transform: "translate(-33.758 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M98.414,284.328,65.576,301.974l29.1,17.177,32.985-17.94Z",
    transform: "translate(-32.725 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M97.381,284.328,66.107,301.133,95.2,318.307l31.428-17.1Z",
    transform: "translate(-31.692 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M96.347,284.328,66.639,300.292,95.72,317.461l29.87-16.25Z",
    transform: "translate(-30.659 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M95.314,284.328,67.17,299.452l29.074,17.165,28.313-15.405Z",
    transform: "translate(-29.626 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M94.281,284.328,67.7,298.611l29.067,17.161,26.756-14.56Z",
    transform: "translate(-28.593 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M93.248,284.328,68.232,297.77l29.06,17.156,25.2-13.715Z",
    transform: "translate(-27.56 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ac",
    d: "M92.215,284.328l-23.451,12.6,29.053,17.153,23.641-12.87Z",
    transform: "translate(-26.526 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ad",
    d: "M91.182,284.328l-21.887,11.76,29.046,17.148,22.084-12.025Z",
    transform: "translate(-25.493 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ae",
    d: "M90.149,284.328,69.826,295.247l29.039,17.144,20.526-11.18Z",
    transform: "translate(-24.46 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M89.116,284.328,70.357,294.406l29.032,17.14,18.969-10.335Z",
    transform: "translate(-23.427 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ag",
    d: "M88.083,284.328l-17.194,9.238L99.914,310.7l17.412-9.49Z",
    transform: "translate(-22.394 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M87.049,284.328l-15.63,8.4,29.018,17.132,15.855-8.645Z",
    transform: "translate(-21.361 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ai",
    d: "M86.016,284.328l-14.066,7.556,29.011,17.128,14.3-7.8Z",
    transform: "translate(-20.328 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M84.983,284.328l-12.5,6.715,29,17.123,12.74-6.955Z",
    transform: "translate(-19.295 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M83.95,284.328,73.013,290.2l29,17.119,11.183-6.11Z",
    transform: "translate(-18.262 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "al",
    d: "M82.917,284.328l-9.373,5.033,28.99,17.115,9.625-5.265Z",
    transform: "translate(-17.229 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "am",
    d: "M81.884,284.328l-7.808,4.192,28.983,17.111,8.068-4.42Z",
    transform: "translate(-16.195 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "an",
    d: "M80.851,284.328l-6.244,3.352,28.976,17.107,6.511-3.575Z",
    transform: "translate(-15.162 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ao",
    d: "M79.818,284.328l-4.68,2.511,28.969,17.1,4.953-2.73Z",
    transform: "translate(-14.129 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ap",
    d: "M78.784,284.328,75.67,286l28.962,17.1,3.4-1.885Z",
    transform: "translate(-13.096 -284.328)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M77.751,284.328l-1.551.829,28.955,17.094,1.839-1.04Z",
    transform: "translate(-12.063 -284.328)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.78)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M104.97,281.929l-2.264-.654a12.555,12.555,0,0,0-10.784,1.861l-2.362-1.752-2.406,5.551-11.623-.989,2.53,10.324a1.923,1.923,0,0,0,1.319,1.381l4.776,1.4a11.614,11.614,0,0,0,11.278-2.736l10.589-10.086A2.55,2.55,0,0,0,104.97,281.929Z",
    transform: "translate(-66.145 -90.361)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M104.97,281.929l-2.264-.654a12.555,12.555,0,0,0-10.784,1.861l-2.362-1.752-2.406,5.551-11.623-.989,1.313,5.357a6.865,6.865,0,0,0,4.735,4.953l2.038.6A11.622,11.622,0,0,0,94.9,294.117l10.586-10.086a2.486,2.486,0,0,0,.721-1.29A2.513,2.513,0,0,0,104.97,281.929Z",
    transform: "translate(-66.145 -90.361)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M88.69,286.618c2.432-2.32,1.782-4.983-1.452-5.916a11.767,11.767,0,0,0-10.274,2.521c-2.421,2.318-1.767,4.98,1.449,5.916A11.764,11.764,0,0,0,88.69,286.618Z",
    transform: "translate(-66.202 -91.158)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.922 86.839)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M78.65,352.535,79.068,311l-3.693-53.377c-.094-3.328,3.69-11.917,7.017-12.012,3.31-.118,13.434,9.682,13.528,13.01L92.57,313.558h0l-3.813,38.791C88.612,355.582,78.5,355.859,78.65,352.535Z",
    transform: "translate(-75.373 -245.61)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M110.51,288.953l-2.047-1.172a12.552,12.552,0,0,0-10.916-.763l-1.879-2.262-3.657,4.818-11.052-3.728v10.63a1.912,1.912,0,0,0,.954,1.655l4.3,2.5a11.618,11.618,0,0,0,11.608.026l12.686-7.276A2.552,2.552,0,0,0,110.51,288.953Z",
    transform: "translate(-55.589 -82.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "as",
    d: "M110.51,288.953l-2.047-1.172a12.552,12.552,0,0,0-10.916-.763l-1.879-2.262-3.657,4.818-11.052-3.728v5.516a6.861,6.861,0,0,0,3.419,5.937l1.838,1.066a11.618,11.618,0,0,0,11.608.029l12.686-7.276a1.085,1.085,0,0,0,0-2.164Z",
    transform: "translate(-55.589 -82.639)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M93.713,291c2.918-1.676,2.918-4.417,0-6.093a11.764,11.764,0,0,0-10.581,0c-2.9,1.676-2.9,4.417,0,6.093A11.782,11.782,0,0,0,93.713,291Z",
    transform: "translate(-55.592 -84.791)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 41.921)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "M88.459,291.383a4.38,4.38,0,0,1-3.8-2.191l-7.93-13.728a32.916,32.916,0,0,1,8.546-42.56l2.167-1.649a4.383,4.383,0,0,1,5.312,6.973l-2.17,1.652a24.128,24.128,0,0,0-6.263,31.2l7.93,13.728a4.386,4.386,0,0,1-3.793,6.576Z",
    transform: "translate(-72.344 -230.356)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.007 40.901)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M76.4,248.138a4.705,4.705,0,0,1-1.846-6.958,36.826,36.826,0,0,1,7.986-8.351l2.235-1.7a5.132,5.132,0,0,1,6.587.159,4.951,4.951,0,0,1-.383,7.55L88.533,240.7a27.139,27.139,0,0,0-5.748,5.966,4.753,4.753,0,0,1-5.9,1.7Z",
    transform: "translate(-73.704 -230.01)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M76.193,268.862l-.424-15.036,24.1-9.255-.2,13.275a6.014,6.014,0,0,1,4.85,5.513l3.316,52.67-3.967,47.938c-.256,3.151-10.987,2.8-10.757,0L91.8,315.578l-1.608-35.29L79.35,274.119A6.258,6.258,0,0,1,76.193,268.862Z",
    transform: "translate(-65.682 -160.79)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "M75.044,259.459l.6-5.76a82.125,82.125,0,0,0,.727-11.938,23.882,23.882,0,0,0,2.694,7.138L87,262.628a4.383,4.383,0,0,1-7.592,4.385Z",
    transform: "translate(-67.092 -166.255)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M75.374,223.417,94.3,234.342a27.121,27.121,0,0,1,13.561,23.487v53.486c-3.843,2.689-10.931,2.158-17.574-.094-.78-.265-3.975-1.567-4.773-1.955-4.673-2.27-8.578-5.312-10.136-8.484l1.234-11.408a81.72,81.72,0,0,0,.695-14.12Z",
    transform: "translate(-66.45 -201.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "M0,0H22.29a0,0,0,0,1,0,0V18.982a6.757,6.757,0,0,1-6.757,6.757H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(16.273 7.624)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "be",
    d: "M0,0H9.32a0,0,0,0,1,0,0V17.23a1.413,1.413,0,0,1-1.413,1.413H1.413A1.413,1.413,0,0,1,0,17.23V0A0,0,0,0,1,0,0Z",
    transform: "translate(19.061 19.001)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bd",
    d: "M93.985,252.771a3.875,3.875,0,0,1-2.474-3.186L89.748,235.9a4.384,4.384,0,0,0-4.909-3.787c-2.4.309-2.518,2.83-2.209,5.23l.188,13.36a12.618,12.618,0,0,0,8.923,10.566,13.084,13.084,0,0,0,2.244.456Z",
    transform: "translate(-52.578 -185.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "M96.522,261.03a12.95,12.95,0,0,1-3.8-.574A12.611,12.611,0,0,1,83.8,249.89l-1.767-13.681a4.384,4.384,0,0,1,8.7-1.122L92.5,248.768a3.988,3.988,0,0,0,6.95,2.123l12.686-14.426a4.383,4.383,0,0,1,6.584,5.786L106.031,256.68A12.614,12.614,0,0,1,96.522,261.03Z",
    transform: "translate(-53.563 -186.669)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M83.184,246.534,81.9,236.6a4.927,4.927,0,0,1,3.3-5.407,4.782,4.782,0,0,1,6.134,3.955l1.31,10.159a4.771,4.771,0,0,1-4.12,5.342h0A4.77,4.77,0,0,1,83.184,246.534Z",
    transform: "translate(-53.836 -187.198)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.479 48.306)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "M91.523,236.39l2.091-2.376A4.383,4.383,0,0,1,100.2,239.8l-2.538,2.889Z",
    transform: "translate(-91.523 -232.524)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "az",
    cx: 5.304,
    cy: 5.304,
    r: 5.304,
    transform: "translate(58.657 46.061)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "az",
    width: 12.013,
    height: 2.342,
    rx: 0.355,
    transform: "matrix(0.689, -0.724, 0.724, 0.689, 59.337, 48.441)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aq",
    d: "M111.521,219.235c-3.849-4.561-12.857-3.207-17.848-1.608-6.146,1.97-13.852,4.27-14.956,11.7a37.532,37.532,0,0,0-.071,5.7,28.332,28.332,0,0,1-2.954,12.7c-2.792,5.613-4.134,9.191-1.175,15.015,1.752,3.448,2.874,8.817,6.452,10.937,3.681,2.179,11.482,3.537,15.006.866,4.912-3.725,7.388-12.742,6.938-18.534-.486-6.252-3.607-12.562-1.714-18.537,1.19-3.743,6.219-7.945,9.067-10.572C112.793,224.568,114.074,222.259,111.521,219.235Z",
    transform: "translate(-71.362 -216.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M101.018,219.219c-2.259-2.677-6.29-3.289-10.245-3.039,2.962.183,5.725,1,7.444,3.039,2.553,3.024,1.272,5.333-1.254,7.668-2.848,2.627-7.877,6.829-9.067,10.572C86,243.434,89.124,249.744,89.61,256c.451,5.792-2.026,14.809-6.938,18.534a8.485,8.485,0,0,1-4.423,1.4c2.774.239,5.507-.094,7.223-1.4C90.384,270.8,92.861,261.788,92.41,256c-.486-6.252-3.61-12.562-1.714-18.537,1.19-3.743,6.219-7.945,9.067-10.572C102.29,224.552,103.571,222.243,101.018,219.219Z",
    transform: "translate(-60.859 -216.104)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M116.571,174.5a4.081,4.081,0,0,0-1.193-.462c-.118-.027-.233-.029-.35-.044a4.1,4.1,0,0,0-.889-.035c-.112.009-.215.026-.324.044a4.183,4.183,0,0,0-.91.259c-.071.026-.141.053-.209.085a4.165,4.165,0,0,0-.987.639h0a4.082,4.082,0,0,0-1.408,3.065l-.515,56.625a5.985,5.985,0,0,0,2.942,5.2s40.876,23.667,49.154,28.455a.968.968,0,0,0,1.452-.842V202.06L116.577,174.5Z",
    transform: "translate(71.399 -37.525)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(176.862 126.309)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M163.892,199.853,115.11,171.094a4.163,4.163,0,0,0-6.278,3.551l-.515,56.625a5.985,5.985,0,0,0,2.942,5.2l48.783,28.755a4.166,4.166,0,0,0,6.281-3.548l.512-56.628A5.98,5.98,0,0,0,163.892,199.853Z",
    transform: "translate(-108.316 -170.511)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bg",
    d: "M161.61,194.459c-3.251-2.432-7.274-4.2-11.3-3.657-3,.4-5.68,2.029-8.257,3.619-3.3,2.035-6.322,4.664-9.447,6.961-3.036,2.232-6.823,4.579-10.321,3.174-3.884-1.561-4.7-6.534-6.4-10.36a17.6,17.6,0,0,0-3.563-5.23,7.741,7.741,0,0,0-3.893-2.147l-.118,12.733a5.985,5.985,0,0,0,2.942,5.2l48.783,28.755a4.074,4.074,0,0,0,2.945.471,4.24,4.24,0,0,0,2.253-1.293c.062-.068.115-.141.171-.212a4,4,0,0,0,.518-.857c.047-.109.1-.212.141-.324a4.1,4.1,0,0,0,.253-1.334l.277-30.67A28.4,28.4,0,0,0,161.61,194.459Z",
    transform: "translate(-108.316 -138.794)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bh",
    d: "M163.076,262.642l.512-56.628a5.976,5.976,0,0,0-2.942-5.2l-48.783-28.755a4.079,4.079,0,0,0-2.895-.48,4.14,4.14,0,0,1,4.871-.486l48.783,28.758a5.98,5.98,0,0,1,2.942,5.2l-.512,56.628a4.138,4.138,0,0,1-3.384,4.028A4.091,4.091,0,0,0,163.076,262.642Z",
    transform: "translate(-107.046 -170.507)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(284.812 136.032)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.414)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M148.092,185.613a1.957,1.957,0,0,1-1.958-1.958v-7.883a1.958,1.958,0,0,1,3.917,0v7.883A1.959,1.959,0,0,1,148.092,185.613Z",
    transform: "translate(-146.134 -173.813)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.971)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M153.757,182.338a1.934,1.934,0,0,1-.978-.262l-6.826-3.94a1.958,1.958,0,0,1,1.958-3.392l6.826,3.943a1.956,1.956,0,0,1-.981,3.651Z",
    transform: "translate(-144.975 -174.482)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.718 83.486)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.414)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M60.786,167.769a1.955,1.955,0,0,1-1.958-1.958v-7.883a1.958,1.958,0,1,1,3.917,0v7.883A1.957,1.957,0,0,1,60.786,167.769Z",
    transform: "translate(-58.828 -155.969)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.972)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M66.451,164.5a1.965,1.965,0,0,1-.978-.262l-6.826-3.94a1.958,1.958,0,0,1,1.958-3.392l6.826,3.94a1.958,1.958,0,0,1-.981,3.654Z",
    transform: "translate(-57.669 -156.639)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(245.544 147.988)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.511)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M133.932,186.551a1.44,1.44,0,0,1-1.44-1.44v-5.8a1.44,1.44,0,0,1,2.88,0v5.8A1.44,1.44,0,0,1,133.932,186.551Z",
    transform: "translate(-132.492 -177.873)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.449)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M138.1,184.143a1.444,1.444,0,0,1-.718-.191l-5.021-2.9a1.44,1.44,0,1,1,1.44-2.494l5.021,2.9a1.439,1.439,0,0,1-.721,2.686Z",
    transform: "translate(-131.639 -178.365)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(188.236 32.639)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.296)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M115.189,150.1A1.891,1.891,0,0,1,113.3,148.2v-7.612a1.892,1.892,0,0,1,3.784,0V148.2A1.891,1.891,0,0,1,115.189,150.1Z",
    transform: "translate(-113.298 -138.702)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.902)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M120.661,146.937a1.887,1.887,0,0,1-.942-.253l-6.593-3.808a1.891,1.891,0,0,1,1.891-3.275l6.593,3.8a1.892,1.892,0,0,1-.948,3.531Z",
    transform: "translate(-112.179 -139.348)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(157.73 38.335)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.838)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M103.494,146.985a1.052,1.052,0,0,1-1.051-1.051V141.69a1.053,1.053,0,1,1,2.105,0v4.243A1.053,1.053,0,0,1,103.494,146.985Z",
    transform: "translate(-102.443 -140.636)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.061)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M106.545,145.224a1.034,1.034,0,0,1-.527-.141l-3.672-2.12a1.054,1.054,0,0,1,1.054-1.826l3.672,2.123a1.053,1.053,0,0,1-.527,1.964Z",
    transform: "translate(-101.819 -140.996)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(232.488 94.199)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.838)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M128.884,165.956a1.053,1.053,0,0,1-1.054-1.054v-4.24a1.053,1.053,0,1,1,2.105,0v4.24A1.053,1.053,0,0,1,128.884,165.956Z",
    transform: "translate(-127.83 -159.607)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.06)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M131.932,164.2a1.073,1.073,0,0,1-.527-.141l-3.672-2.12a1.054,1.054,0,0,1,1.054-1.826l3.672,2.12a1.054,1.054,0,0,1-.527,1.967Z",
    transform: "translate(-127.206 -159.967)"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.182 146.678)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.512)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M67.59,186.1a1.436,1.436,0,0,1-1.44-1.437v-5.8a1.44,1.44,0,1,1,2.88,0v5.8A1.438,1.438,0,0,1,67.59,186.1Z",
    transform: "translate(-66.15 -177.428)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.448)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M71.758,183.7a1.428,1.428,0,0,1-.719-.191l-5.021-2.9a1.441,1.441,0,0,1,1.44-2.5l5.021,2.9a1.439,1.439,0,0,1-.721,2.686Z",
    transform: "translate(-65.297 -177.92)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.31 55.585)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.511)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M76.8,155.172a1.44,1.44,0,0,1-1.44-1.44v-5.8a1.44,1.44,0,0,1,2.88,0v5.8A1.438,1.438,0,0,1,76.8,155.172Z",
    transform: "translate(-75.362 -146.494)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.447)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M80.969,152.765a1.444,1.444,0,0,1-.719-.191l-5.021-2.9a1.441,1.441,0,0,1,1.44-2.5l5.021,2.9a1.439,1.439,0,0,1-.721,2.686Z",
    transform: "translate(-74.509 -146.985)"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.422 203.626)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M137.626,205.445a1.438,1.438,0,0,1-1.44-1.44v-5.8a1.44,1.44,0,1,1,2.88,0v5.8A1.436,1.436,0,0,1,137.626,205.445Z",
    transform: "translate(-136.186 -196.767)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.45)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M141.793,203.039a1.444,1.444,0,0,1-.719-.191l-5.018-2.9a1.44,1.44,0,1,1,1.44-2.494l5.018,2.9a1.439,1.439,0,0,1-.721,2.686Z",
    transform: "translate(-135.334 -197.259)"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(272.07 61.362)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.511)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M142.94,157.134a1.44,1.44,0,0,1-1.44-1.44v-5.8a1.44,1.44,0,1,1,2.88,0v5.8A1.44,1.44,0,0,1,142.94,157.134Z",
    transform: "translate(-141.5 -148.456)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.449)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M147.107,154.726a1.444,1.444,0,0,1-.719-.191l-5.021-2.9a1.44,1.44,0,1,1,1.44-2.494l5.021,2.9a1.439,1.439,0,0,1-.721,2.686Z",
    transform: "translate(-140.647 -148.948)"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.625 23.717)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.511)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M67.74,144.347a1.438,1.438,0,0,1-1.44-1.44v-5.8a1.44,1.44,0,0,1,2.88,0v5.8A1.438,1.438,0,0,1,67.74,144.347Z",
    transform: "translate(-66.3 -135.672)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1.447)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M71.907,141.943a1.445,1.445,0,0,1-.719-.191l-5.021-2.9a1.44,1.44,0,0,1,1.44-2.494l5.021,2.9a1.441,1.441,0,0,1-.721,2.689Z",
    transform: "translate(-65.447 -136.163)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M132.1,204.239c-.386-.224-.7-.041-.7.406a1.575,1.575,0,0,0,.7,1.225c.389.224.707.038.707-.409A1.565,1.565,0,0,0,132.1,204.239Z",
    transform: "translate(113.439 21.205)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M133.937,188.422c-.389-.224-.707-.041-.707.409a1.565,1.565,0,0,0,.707,1.222c.389.224.707.041.707-.409A1.565,1.565,0,0,0,133.937,188.422Z",
    transform: "translate(116.997 -9.555)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M134.417,152.8c-.389-.224-.707-.041-.707.409a1.565,1.565,0,0,0,.707,1.222c.386.224.7.041.7-.409A1.57,1.57,0,0,0,134.417,152.8Z",
    transform: "translate(117.931 -78.825)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M63.955,169.6c-.389-.224-.707-.041-.707.409a1.565,1.565,0,0,0,.707,1.222c.389.224.707.041.707-.406A1.566,1.566,0,0,0,63.955,169.6Z",
    transform: "translate(-19.1 -46.154)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M145.346,193.827c-.639-.368-1.157-.068-1.157.668a2.566,2.566,0,0,0,1.157,2.005c.636.365,1.157.065,1.157-.668A2.565,2.565,0,0,0,145.346,193.827Z",
    transform: "translate(138.31 0.836)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M56.941,169.391c-.769-.442-1.4-.079-1.4.807a3.1,3.1,0,0,0,1.4,2.421c.769.445,1.4.082,1.4-.807A3.1,3.1,0,0,0,56.941,169.391Z",
    transform: "translate(-34.086 -46.746)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M94.186,133.814c-.636-.368-1.157-.068-1.157.668a2.574,2.574,0,0,0,1.157,2.005c.636.368,1.157.065,1.157-.668A2.569,2.569,0,0,0,94.186,133.814Z",
    transform: "translate(38.817 -115.875)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M58.9,144.742c-.636-.368-1.157-.068-1.157.668a2.569,2.569,0,0,0,1.157,2.005c.636.368,1.157.068,1.157-.668A2.569,2.569,0,0,0,58.9,144.742Z",
    transform: "translate(-29.8 -94.622)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M76.517,181.536c-.636-.368-1.157-.068-1.157.668a2.574,2.574,0,0,0,1.157,2.005c.636.365,1.157.065,1.157-.668A2.569,2.569,0,0,0,76.517,181.536Z",
    transform: "translate(4.455 -23.067)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M138.641,165.373c-.9-.518-1.631-.094-1.631.942a3.626,3.626,0,0,0,1.631,2.824c.9.518,1.631.094,1.631-.942A3.613,3.613,0,0,0,138.641,165.373Z",
    transform: "translate(124.349 -54.624)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M116.184,153.546c-.9-.515-1.631-.094-1.631.942a3.614,3.614,0,0,0,1.631,2.824c.9.518,1.631.094,1.631-.939A3.627,3.627,0,0,0,116.184,153.546Z",
    transform: "translate(80.675 -77.622)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M80.523,133.362c-1.458-.842-2.65-.153-2.65,1.528a5.88,5.88,0,0,0,2.65,4.591c1.458.842,2.65.153,2.65-1.531A5.874,5.874,0,0,0,80.523,133.362Z",
    transform: "translate(9.342 -117.146)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M128.956,140.194c-1.458-.839-2.65-.153-2.65,1.531a5.884,5.884,0,0,0,2.65,4.591c1.458.839,2.65.153,2.65-1.531A5.884,5.884,0,0,0,128.956,140.194Z",
    transform: "translate(103.532 -103.859)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M103.672,127.871c-1.025-.592-1.861-.109-1.861,1.072a4.121,4.121,0,0,0,1.861,3.222c1.022.589,1.858.106,1.858-1.075A4.12,4.12,0,0,0,103.672,127.871Z",
    transform: "translate(55.895 -127.618)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "bi",
    d: "M94.636,209.79l4.081-1.734V198.008a2.785,2.785,0,0,1,.144-.889v-.141a1.359,1.359,0,0,1,.409-.972c1.419-1.393,5.121-1.437,6.841-.442L180.8,239.785l-.306,40.658c0,2.179-46.286-28-48.388-27.424a3.288,3.288,0,0,1-2.512-.324l-.3-.171c-.047-.026-.091-.038-.138-.065L98.717,234.882v-9.918L93.529,212.5A2.08,2.08,0,0,1,94.636,209.79Z",
    transform: "translate(39.477 3.189)"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(135.467 205.055)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M96.533,198.377h0c1.419-1.39,5.118-1.437,6.841-.442l99.2,57.355a6.237,6.237,0,0,1,2.812,4.871v41.727a3.9,3.9,0,0,1-2.647,3.69h0a1.513,1.513,0,0,1-1.425-.277L99.175,246.924a6.294,6.294,0,0,1-3.051-4.756V199.352A1.361,1.361,0,0,1,96.533,198.377Z",
    transform: "translate(-90.631 -197.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M99.607,199.639c0-1.785,1.263-2.518,2.812-1.623l100.163,57.829a6.242,6.242,0,0,1,2.812,4.871V302.64c0,1.787-1.266,2.518-2.812,1.623L102.42,246.434a6.229,6.229,0,0,1-2.812-4.871V226.6L94.419,214.13a2.076,2.076,0,0,1,1.1-2.709l4.084-1.737Z",
    transform: "translate(-94.259 -196.509)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.731 16.621)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "M158.227,240,100.286,206.65l-.007-3.754,57.947,33.285Z",
    transform: "translate(-100.28 -202.896)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.731 29.476)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "M158.227,244.254,100.28,211.011v-3.75l57.947,33.285Z",
    transform: "translate(-100.28 -207.262)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.731 43.11)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "M132.513,234.08,100.28,215.642v-3.75l32.233,18.482Z",
    transform: "translate(-100.28 -211.892)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M121.044,213.649l.081,36.1,26.014,14.889V228.458Z",
    transform: "translate(-42.168 -165.363)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageLogin);
export default __webpack_public_path__ + "static/media/image-login.7252773e5a8ea538c3be02ba04c062ad.svg";
export { ForwardRef as ReactComponent };